module.exports = __webpack_public_path__ + "img/discuss_your_quote.f00a01c8.png";